package com.eladfinish.bible.contest.screens.main.data

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.unit.dp

/**
 * Custom "pyramid crossword" icon: rounded crossword cells stacked into a
 * 1-2-3-4 pyramid, mirroring the in-app pyramid layout. Tinted at render time,
 * so the fill color here is irrelevant.
 */
val PyramidCrosswordIcon: ImageVector by lazy {
    ImageVector.Builder(
        name = "PyramidCrossword",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = 24f,
        viewportHeight = 24f,
    ).apply {
        addPath(PathParser().parsePathString(CELLS_PATH).toNodes(), fill = SolidColor(Color.Black))
    }.build()
}

private const val CELLS_PATH =
    "M10.70 2.20H13.30A0.7 0.7 0 0 1 14.00 2.90V5.50A0.7 0.7 0 0 1 13.30 6.20H10.70A0.7 0.7 0 0 1 10.00 5.50V2.90A0.7 0.7 0 0 1 10.70 2.20ZM8.10 7.40H10.70A0.7 0.7 0 0 1 11.40 8.10V10.70A0.7 0.7 0 0 1 10.70 11.40H8.10A0.7 0.7 0 0 1 7.40 10.70V8.10A0.7 0.7 0 0 1 8.10 7.40ZM13.30 7.40H15.90A0.7 0.7 0 0 1 16.60 8.10V10.70A0.7 0.7 0 0 1 15.90 11.40H13.30A0.7 0.7 0 0 1 12.60 10.70V8.10A0.7 0.7 0 0 1 13.30 7.40ZM5.50 12.60H8.10A0.7 0.7 0 0 1 8.80 13.30V15.90A0.7 0.7 0 0 1 8.10 16.60H5.50A0.7 0.7 0 0 1 4.80 15.90V13.30A0.7 0.7 0 0 1 5.50 12.60ZM10.70 12.60H13.30A0.7 0.7 0 0 1 14.00 13.30V15.90A0.7 0.7 0 0 1 13.30 16.60H10.70A0.7 0.7 0 0 1 10.00 15.90V13.30A0.7 0.7 0 0 1 10.70 12.60ZM15.90 12.60H18.50A0.7 0.7 0 0 1 19.20 13.30V15.90A0.7 0.7 0 0 1 18.50 16.60H15.90A0.7 0.7 0 0 1 15.20 15.90V13.30A0.7 0.7 0 0 1 15.90 12.60ZM2.90 17.80H5.50A0.7 0.7 0 0 1 6.20 18.50V21.10A0.7 0.7 0 0 1 5.50 21.80H2.90A0.7 0.7 0 0 1 2.20 21.10V18.50A0.7 0.7 0 0 1 2.90 17.80ZM8.10 17.80H10.70A0.7 0.7 0 0 1 11.40 18.50V21.10A0.7 0.7 0 0 1 10.70 21.80H8.10A0.7 0.7 0 0 1 7.40 21.10V18.50A0.7 0.7 0 0 1 8.10 17.80ZM13.30 17.80H15.90A0.7 0.7 0 0 1 16.60 18.50V21.10A0.7 0.7 0 0 1 15.90 21.80H13.30A0.7 0.7 0 0 1 12.60 21.10V18.50A0.7 0.7 0 0 1 13.30 17.80ZM18.50 17.80H21.10A0.7 0.7 0 0 1 21.80 18.50V21.10A0.7 0.7 0 0 1 21.10 21.80H18.50A0.7 0.7 0 0 1 17.80 21.10V18.50A0.7 0.7 0 0 1 18.50 17.80Z"
